import Step from "components/MainApp/atoms/Wizard/Step";
import React from "react";

import MainDropdown from "components/MainApp/atoms/Forms/MainDropdown";
import styles from "./LoadRelocationOrder.Step3.module.scss";
import i18n from "i18n";

export const RelOrderStep3 = ({ options, option, handleChange }) => {
  const stepContent = (
    <div className={styles["relocation-order-step-three-content"]}>

      <div
        className={styles["relocation-order-step-three-field"]}
        data-automation-id="input-name"
      >
        <MainDropdown
          label={i18n.t("select")}
          placeholder={i18n.t("select")}
          required={true}
          id={"dest"}
          name="dest"
          value={option}
          selectedOption={option}
          options={options}
          handleChange={handleChange}
          handleSelection={handleChange}
        />
      </div>
    </div>
  );
  return (
    <div className={styles["relocation-order-step-three-container"]}>
      <Step
        title={i18n.t("select.destination.order")}
        content={stepContent}
      ></Step>
    </div>
  );
};

export default RelOrderStep3;
